export const LEGAJO_UNICO = 999999
